import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import apis from '../../api'
import { FileUpload } from 'primereact/fileupload'
import fileToBase64 from '../../services/fileToBase64'
import { Button } from 'primereact/button'
import { useRef } from 'react'
import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar'
import { Tag } from 'primereact/tag'
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip'

const ValidateDocument = () => {

    const [document, setDocument] = useState({})
    const [signs, setSigns] = useState({
        USERS: [],
        DATES: [],
        CITIES: []
    })
    const [files, setFiles] = useState([])
    const [loading, setLoading] = useState(false)
    const [validation, setValidation] = useState(false)
    const fileUploadRef = useRef(null);
    const toast = useRef(null);
    const [totalSize, setTotalSize] = useState(0);

    const verifyDocument = async () => {
        setValidation(false)
        setLoading(true)
        if (files.length > 0) {
            let _archivo = files[0]
            let base64 = ""

            await fileToBase64(_archivo).then(res => {
                base64 = res
            })

            const payload = {
                PARAMS: [
                    {
                        FILE: base64
                    }
                ]
            }
            try {
                await apis.verifySignature(payload).then(res => {
                    let document = res.data
                    let newDocument = {}
                    Object.keys(document).map((key, i) => {
                        let newKey = key.split('/')[1]
                        newDocument[newKey] = document[key] 
                    })
                    setDocument(newDocument)
                    setSigns({
                        USERS: newDocument['Usuarios'].replace(/[\[\]']/g, '').split(',').map(s => s.trim()),
                        DATES: newDocument['Fechas'].replace(/^\[|\]$/g, '').split("', '").map(s => s.replace(/'/g, '').trim()),
                        CITIES: newDocument['Ciudades'].replace(/[\[\]']/g, '').split(',').map(s => s.trim()),
                    })
                    setLoading(false)
                    setValidation(true)
                })
            }
            catch (err) {
                console.log(err.response.data)
                let msg = err.response.data.message.split('[')[1]
                msg = msg.split(']')[0]
                setLoading(false)
                setValidation(false)
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: msg, sticky: true });
            }
        }
    }

    const onTemplateSelect = (e) => {
        setTotalSize(0)
        let files = e.files;
        if (files.length > 0) {
            setTotalSize(files[0].size);
            setDocument({})
            setValidation(false)
            setFiles(files)
        }
    };

    const onTemplateUpload = (e) => {
        verifyDocument()
    };

    const onTemplateRemove = (file, callback) => {
        setFiles([])
        setDocument({})
        setValidation(false)
        setTotalSize(0)
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
        setFiles([])
        setDocument({})
        setValidation(false)
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 20000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 2 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center justify-content-center" >
                {!loading ?
                    <><div className="flex flex-row align-items-center" style={{ width: '100%' }}>
                        <span className="flex flex-column text-left ">
                            {file.name}
                        </span>
                        <Tag value={props.formatSize} severity="warning" className="ml-3" />
                    </div>
                        <Button type="button" icon="pi pi-times" className="p-button-rounded p-button-danger ml-auto" disabled={loading} onClick={() => onTemplateRemove(file, props.onRemove)} /></> :
                    <div className="flex flex-column align-items-center justify-content-center">
                        <ProgressSpinner />
                        Validando...
                    </div>
                }
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-file-pdf mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Selecciona un archivo o arrastralo aquí
                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-file-pdf', iconOnly: false, className: 'custom-choose-btn p-button-rounded' };
    const uploadOptions = { icon: 'pi pi-fw pi-check', iconOnly: false, className: 'custom-upload-btn p-button-success p-button-rounded' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: false, className: 'custom-cancel-btn p-button-danger p-button-rounded' };

    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container yellow-container flex-column">

            <div style={
                {
                    marginBottom: "2rem",
                    marginTop: "5rem",
                }
            }
                className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                <span className="text-900">Validación firma digital</span>
            </div>
            <div>
                <Toast ref={toast} />
                <FileUpload className='card'
                    name="demo[]" ref={fileUploadRef} accept="application/pdf" maxFileSize={2000000} chooseLabel="Seleccionar" uploadLabel='Validar' cancelLabel='Cancelar' onValidationFail={() => {
                        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                    }}
                    onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                    headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                    chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions}
                    customUpload uploadHandler={verifyDocument}
                />
            </div>
            {validation && <div className='flex flex-wrap card-container flex-column justify-content-start align-items-cemter p-3 m-1'
                style={
                    {
                        backgroundColor: "#1061a2",
                        borderRadius: "20px",
                        border: "1px solid #ccc",
                        width: "40rem"
                    }
                }>
                {Object.keys(document).map((key, i) => {
                    if(!(["Usuarios", "Fechas", "Ciudades"].includes(key))){
                        return (
                            <div key={i} className='flex flex-wrap justify-self-start'>
                                <p>
                                    <span className='text-900 font-bold text-white'>
                                        {key.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}:&nbsp;
                                    </span>
                                    <span className='text-900 text-white' style={{ wordBreak: 'break-all' }}>
                                        {document[key].normalize("NFD").replace(/[\u0300-\u036f]/g, "")}
                                    </span>
                                </p>
                            </div>
                        )
                    }
                })}
                <div className='flex flex-wrap justify-self-start'>
                    <span className='text-900 font-bold text-white'>Firmas:</span>
                </div>
                <div className='flex flex-wrap justify-self-start'>
                    {signs.USERS.map((key, i) => {
                        const label = "\u2022 " + key + ' ' + signs.DATES[i] + ' ' + signs.CITIES[i] 
                        return(
                            <div key={i} className='flex flex-wrap justify-self-start'>
                                <span className='text-900 text-white' style={{ wordBreak: 'break-all' }}>
                                    {label.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>}
        </div>
    )
}

export default ValidateDocument;
